module.exports = __webpack_public_path__ + "img/icon-chanel-text.2c668749.svg";